import { slices } from "@/constants/sliceNames";
import { Prefixs } from "@/socket/socketPrefix";
import { cameraWebSocket } from "@/store/effects/camera/utils";
import { WEBSOCKET_ERROR, WEBSOCKET_MESSAGE } from "@giantmachines/redux-websocket/dist";
import { createSlice } from "@reduxjs/toolkit";

import { Camera, CameraImage, CameraODImage } from "../../../entities/Camera";
import {
  requestListOfCamerasStatus,
  requestSingleCameraDetailsStatus,
  requestCameraImagesStatus,
  requestSingleImageDetailsStatus,
  requestConnectCameraStatus,
  requestDisconnectCameraStatus,
  requestCreateCameraStatus,
  requestUpdateCameraStatus,
  requestDeleteCameraStatus,
  requestTestCameraConfigStatus,
  requestTestCameraStatus,
  requestCameraModelDetailsStatus,
  requestNumberOfImagesStatus,
  requestRemoveCameraFromGroupStatus,
  startCameraStreamingStatuses,
} from "../../effects/camera/camera-effects";

const initialState = {
  /** @type {Camera[]} */
  cameraList: [],
  /** @type {Camera} */
  camera: new Camera(),
  /** @type {boolean} */
  loading: false,
  /** @type {number} */
  currentPage: 0,
  /** @type {number} */
  pageLimit: 0,
  /** @type {number} */
  recordsCount: 0,
  /** @type {number} */
  totalPages: 0,
  /** @type {string} */
  message: "",
  /** @type {string} */
  error: "",
  /** */
  connection: {
    /** @type {boolean} */
    loading: false,
    /** @type {string} */
    error: "",
    /** @type {string} */
    message: "",
  },
  /** */
  streaming: {
    /** @type {boolean} */
    isStreaming: false,
    /** @type {CameraImage | CameraODImage} */
    prediction: null,
    /** @type {String} */
    test_connection_img: null,
  },
  /** */
  images: {
    /** @type {boolean} */
    loading: false,
    /** @type {string} */
    error: "",
    /** @type {string} */
    message: "",
    /** @type {key: CameraImage | CameraODImage} */
    imagesList: [],
    /** @type {CameraImage | CameraODImage} */
    image: null,
    /** @type {number} */
    pageLimit: 0,
    /** @type {number} */
    recordsCount: 0,
    /** @type {number} */
    currentPage: 0,
    /** @type {number} */
    totalPages: 0,
    /** @type {object} */
    appliedFiltersOnImages: {},
  },
  /** @type {Object} */
  cameraModel: {},

  // This is to hold number of images in camera
  // used to display in camera details
  // As it requires another API call to get this
  // so It's added outside camera state to avoid overriding
  /** @type {number} */
  cameraSize: 0,
};

const cameraSlice = createSlice({
  name: slices.camera,
  initialState,
  reducers: {
    startCameraSocketStreaming: (state, action) => {
      state.streaming.isStreaming = true;
      state.streaming.prediction = null;
    },
    startCameraStreaming: (state, action) => {
      state.streaming.isStreaming = true;
      state.streaming.prediction = null;
    },
    stopCameraStreaming: (state, action) => {
      state.streaming.isStreaming = false;
      state.streaming.prediction = null;
      state.streaming.test_connection_img = null;
    },
    resetCameras: (state, action) => initialState,
  },
  extraReducers: {
    ...requestListOfCamerasStatus,
    ...requestSingleCameraDetailsStatus,
    ...requestCameraImagesStatus,
    ...requestSingleImageDetailsStatus,
    ...requestConnectCameraStatus,
    ...requestDisconnectCameraStatus,
    ...requestCreateCameraStatus,
    ...requestUpdateCameraStatus,
    ...requestDeleteCameraStatus,
    ...requestTestCameraConfigStatus,
    ...requestTestCameraStatus,
    ...requestCameraModelDetailsStatus,
    ...requestNumberOfImagesStatus,
    ...requestRemoveCameraFromGroupStatus,
    ...startCameraStreamingStatuses,

    [`${Prefixs.CAMERA_PREFIX}::${WEBSOCKET_MESSAGE}`]: (state, action) => {
      const data = JSON.parse(action.payload?.message);
      state.camera.size += 1;
      state.streaming = cameraWebSocket(state.streaming, data.type, data);
    },
    [`${Prefixs.CAMERA_PREFIX}::${WEBSOCKET_ERROR}`]: (state, action) => {
      state.streaming.test_connection_img = null;
    },
  },
});

const { actions, reducer } = cameraSlice;

export const { startCameraSocketStreaming, stopCameraStreaming, startCameraStreaming, resetCameras } = actions;

export default reducer;
